// extracted by mini-css-extract-plugin
module.exports = {"benefitsImageDiv":"benefits_benefitsImageDiv__stlmM","benefitsText":"benefits_benefitsText__C7sdt","benefitsImage":"benefits_benefitsImage__RAY4f"};